import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createPortal } from 'react-dom';
import { BsFillChatLeftDotsFill } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import { MdLogout } from "react-icons/md";

import '../css/sidebar.css';
import '../css/modal.css';

const Sidebar = ({ isOpen, toggleSidebar }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const menuItems = [
        {
            title: 'Dashboard',
            path: '/dashboard',
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="7" height="7"></rect>
                    <rect x="14" y="3" width="7" height="7"></rect>
                    <rect x="14" y="14" width="7" height="7"></rect>
                    <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
            )
        },
        {
            title: 'Users Management',
            path: '/users-management',
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
            )
        },
        {
            title: 'Content Management',
            path: '/content-management',
            icon: <BsFillChatLeftDotsFill />
        },
        {
            title: 'Creator Performance',
            path: '/revenue-per-creator',
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
            )
        },
        {
            title: 'Reports',
            path: '/reports',
            icon: (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                    <line x1="4" y1="22" x2="4" y2="15"></line>
                </svg>
            )
        },
    ];

    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const handleLogout = () => {
        setShowLogoutModal(true);
    };

    const confirmLogout = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("id");
        localStorage.removeItem("first_name");
        localStorage.removeItem("email");
        setShowLogoutModal(false);
        navigate("/");
    };

    return (
        <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-header" style={{ justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <img
                        src="/logo.png"
                        alt="Fanatech"
                        style={{ height: '36px', width: 'auto', objectFit: 'contain' }}
                    />
                    <h2 className="logo-text">Fanatech</h2>
                </div>
                {/* Close Button for Mobile */}
                <div className="sidebar-close-btn" onClick={toggleSidebar}>
                    <IoMdClose size={24} />
                </div>
            </div>
            <nav className="sidebar-nav">
                <ul>
                    {menuItems.map((item, index) => {
                        const isActive = location.pathname.startsWith(item.path);
                        return (
                            <li
                                key={index}
                                className={`nav-item ${isActive ? 'active' : ''}`}
                                onClick={() => {
                                    navigate(item.path);
                                    // Close sidebar on navigation on mobile
                                    if (window.innerWidth <= 1024) {
                                        toggleSidebar();
                                    }
                                }}
                            >
                                <span className="nav-icon">{item.icon}</span>
                                <span className="nav-title">{item.title}</span>
                            </li>
                        );
                    })}
                </ul>
            </nav>

            <div className="sidebar-footer mobile-logout">
                <div className="nav-item logout-item" onClick={handleLogout}>
                    <span className="nav-icon"><MdLogout size={20} /></span>
                    <span className="nav-title">Logout</span>
                </div>
            </div>

            {/* Logout Confirmation Modal */}
            {showLogoutModal && createPortal(
                <div className="modal-overlay">
                    <div
                        className="modal-content"
                        style={{
                            maxWidth: "400px",
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                backgroundColor: "#fef2f2",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "1rem",
                                color: "#ef4444",
                                fontSize: "1.8rem",
                            }}
                        >
                            <MdLogout />
                        </div>
                        <h3 className="modal-title" style={{ marginBottom: "10px" }}>
                            Confirm Logout
                        </h3>
                        <p style={{ color: "#666", marginBottom: "20px" }}>
                            Are you sure you want to log out of your account?
                        </p>
                        <div
                            className="modal-actions"
                            style={{
                                justifyContent: "center",
                                marginTop: "1rem",
                                width: "100%",
                                display: "flex",
                                gap: "10px"
                            }}
                        >
                            <button
                                onClick={() => setShowLogoutModal(false)}
                                className="btn-secondary"
                                style={{ width: "120px" }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={confirmLogout}
                                className="btn-primary"
                                style={{
                                    backgroundColor: "#ef4444",
                                    width: "120px",
                                    boxShadow: "0 4px 12px rgba(239, 68, 68, 0.2)",
                                }}
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </aside>
    );
};

export default Sidebar;